import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import { ReactElement, useState } from "react";

import { LinkButton } from "~frontend/components/Link";
import { useSubaccountAdminConfig } from "~frontend/providers/SubaccountProvider";
import theme from "~frontend/theme";
import { spacingArray } from "~frontend/util/styling";

import { CampaignForView } from "../types";
import RoiSettingsForm, { roiFormValuesFromCampaign } from "./RoiSettingsForm";

function RoiViewDialog({
  campaign,
  handleClose,
}: {
  campaign: CampaignForView;
  handleClose: () => void;
}) {
  const subaccount = useSubaccountAdminConfig()!;

  return (
    <Formik
      initialValues={roiFormValuesFromCampaign(campaign, subaccount)}
      onSubmit={() => {}}
    >
      <>
        <DialogTitle>{campaign.name} Conditional Winner Settings</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
            paddingBottom: theme.spacing(2),
          }}
        >
          <RoiSettingsForm readOnly campaign={campaign} />
        </DialogContent>
        <DialogActions
          sx={{
            padding: spacingArray([0, 3, 3]),
          }}
        >
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </>
    </Formik>
  );
}

export default function RoiTestSummary({
  campaign,
}: {
  campaign: CampaignForView;
}): ReactElement | null {
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!campaign.roiTestConfig) {
    return null;
  }

  return (
    <Typography sx={{ mb: 2 }}>
      There is a test running to determine which script variant will be sent to
      your full list (
      <LinkButton
        onClick={evt => {
          evt.preventDefault();
          setDialogOpen(true);
        }}
      >
        view settings
      </LinkButton>
      ).
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        {dialogOpen && (
          <RoiViewDialog
            campaign={campaign}
            handleClose={() => setDialogOpen(false)}
          />
        )}
      </Dialog>
    </Typography>
  );
}
